import Vue from 'vue'

require('./bootstrap')
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import RootQuickAccess from "./components/RootQuickAccess";
import CitySelectModal from "./components/CitySelectModal";
import TypeSearch from "./components/TypeSearch";
import ServiceRequest from "./components/ServiceRequest";
import PartsRequest from "./components/PartsRequest";

Vue.use(VueSweetalert2);

const app = new Vue({
    el: '#app',

    components: {
        'city-select-modal': CitySelectModal,
        'root-quick-access': RootQuickAccess,
        'type-search': TypeSearch,
        'service-request': ServiceRequest,
        'parts-request': PartsRequest,

    },
})

